



































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { mask } from "vue-the-mask";

@Component({ inheritAttrs: false, directives: { mask } })
export default class ppdwYearPicker extends Vue {
    @Prop({ default: () => [] }) rules: Function[];
    @Prop() value: number;
    @Prop({ default: "" }) label: string;
    @Prop({ default: "____" }) placeholder: string;
    @Prop() max: number;
    @Prop() min: number;
    @Prop({ default: false }) readonly: boolean;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) hideDetails: boolean;
    @Prop({ default: "250px" }) minWidth: string;
    @Prop({ default: 50 }) nudgeBottom: number;
    @Prop({ default: 0 }) nudgeTop: number;
    @Prop(Boolean) top: boolean;

    year: any = new Date().toPicker();
    menu: boolean = false;
    svg = require("@/assets/img/ppdw-calendar.svg");

    get allRules() {
        return [...this.rules, this.minDateRule, this.maxDateRule];
    }

    get maxPicker(): string {
        if (!!this.max)
            return new Date(
                new Date().setFullYear(this.max + 1, 0, 0)
            ).toPicker();
        else return "";
    }
    get minPicker(): string {
        //озможен переход на панель выбора месяца => проверить формирующиюся строку
        if (!!this.min)
            return new Date(new Date().setFullYear(this.min, 0, 1)).toPicker();
        else return "";
    }

    get Value(): number {
        return this.value;
    }
    set Value(val) {
        this.$emit("input", val);
    }

    yearChange(val: string) {
        this.$emit("input", new Date(val).getFullYear());
        this.menu = false;
    }

    @Watch("menu") picClick(val) {
        this.$nextTick(() => {
            this.$refs.picker["activePicker"] = "YEAR";
        });
    }

    firstValidStep(val): boolean {
        if (
            !val ||
            val.toString().length != 4 ||
            (!!this.max && val > this.max) ||
            (!!this.min && val < this.min)
        )
            return false;
        else return true;
    }

    @Watch("Value")
    onValueChange(newVal) {
        if (!this.firstValidStep(newVal)) return;
        this.checkSuccess(this.value, this.rules);
        this.year = new Date(new Date().setFullYear(newVal, 0, 1)).toPicker();
    }

    minDateRule(v: number) {
        if (!this.min) return true;
        if (!this.firstValidStep(v)) return "Неверная дата";
        if (this.min <= v) return true;
        else return "Неверная дата";
    }
    maxDateRule(v: number) {
        if (!this.max) return true;
        if (!this.firstValidStep(v)) return "Неверная дата";
        if (this.max >= v) return true;
        else return "Неверная дата";
    }

    async mounted() {
        this.checkSuccess(this.value, this.rules);
    }
    handleInput(val) {
        this.checkSuccess(val, this.rules);
        this.$emit("input", val);
    }
    @Prop({ default: true }) successable: boolean;
    success: boolean = false;
    checkSuccess(value, rules) {
        if (!rules) {
            this.success = true;
            return;
        }
        let state = false;
        for (let rule of rules) {
            if (typeof rule(value) === "string") {
                state = false;
                break;
            } else state = true;
        }
        this.success = state;
    }
}
